/* eslint-disable react/display-name */
import { Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styles from 'src/styles/layout.module.css';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'src/index';
import CompanyCheckinPercentage from 'src/components/pages/Company/CompanyPage/CompanyParametersTab/CompanyCheckinPercentage';
import { fetchCompanyParameters } from 'src/features/companyParameters/companyParameters.state';
import { useCompanyParametersState } from 'src/features/companyParameters/companyParameters.hooks';
import LoaderWrapper from 'src/components/atoms/LoaderWrapper';
import CompanyWorkingHeadsetsNumber from 'src/components/pages/Company/CompanyPage/CompanyParametersTab/CompanyWorkingHeadsetsNumber';

const CompanyParametersTab: React.FC = () => {
  const { companyId } = useParams() as { companyId: string };
  const dispatch: AppDispatch = useDispatch();
  const state = useCompanyParametersState();

  useEffect(() => {
    dispatch(fetchCompanyParameters({ companyId }));
  }, [companyId, dispatch]);

  return (
    <div className={styles.root}>
      <LoaderWrapper loading={state.isPending}>
        <Row gutter={24}>
          <Col span={12}>
            <CompanyWorkingHeadsetsNumber />
          </Col>
          <Col span={12}>
            <CompanyCheckinPercentage />
          </Col>
        </Row>
      </LoaderWrapper>
    </div>
  );
};

export default CompanyParametersTab;
